module.exports = __webpack_public_path__ + "img/characters.81c2f334.png";